import { SidenavMenu } from '../components/shared/sidebar/sidebar-menu.model';
import { ApiFile } from './apifile';

// Product Tag
export type ProductTags = 'nike' | 'puma' | 'lifestyle' | 'caprese';

// Product Colors
export type ProductColor = 'white' | 'black' | 'red' | 'green' | 'purple' | 'yellow' | 'blue' | 'gray' | 'orange' | 'pink';



export class Product {
  id?: number;
  slug?: string;
  name?: string;
  linkvideo?: string;
  price?: number;
  salePrice?: number;
  discount?: number;
  pictures?: string;
  shortDetails?: string;
  description?: string;
  stock?: number;
  newPro?: boolean;
  brand?: string;
  sale?: boolean;
  category?: SidenavMenu;
  tags?: ProductTags[];
  colors?: ProductColor[];
  // tslint:disable-next-line:variable-name
  sell_in_ligne?: boolean;

  images?: ApiFile[];
  // tslint:disable-next-line:variable-name
  image_principale?: ApiFile;
  categories?: any[];
  // tslint:disable-next-line:variable-name
  fichier_telechargeable?: ApiFile;

  by?: string;
  type?: string;
  isPublish?: boolean;
  souscribe_mode?: string;
  nbr_oders: number;
  other_file: ApiFile[];
  external_link: string;
  is_external_link: boolean;




  constructor(
    id?: number,
    name?: string,
    price?: number,
    salePrice?: number,
    discount?: number,
    pictures?: string,
    shortDetails?: string,
    description?: string,
    stock?: number,
    newPro?: boolean,
    brand?: string,
    sale?: boolean,
    category?: SidenavMenu,
    tags?: ProductTags[],
    colors?: ProductColor[],
    linkvideo?: string,
    // tslint:disable-next-line:variable-name
    sell_in_ligne?: boolean,
    images?: ApiFile[],
    // tslint:disable-next-line:variable-name
    image_principale?: ApiFile,
    categories?: any[],
    // tslint:disable-next-line:variable-name
    fichier_telechargeable?: ApiFile,
    by?: string,
    type?: string,
    isPublish?: boolean,
    souscribe_mode?: string,
    nbr_oders?: number,
    other_file?: ApiFile[],
    is_external_link?: boolean,
    external_link?: string,
  ) {
    this.id = id;
    this.name = name;
    this.price = price;
    this.salePrice = salePrice;
    this.discount = discount;
    this.pictures = pictures;
    this.shortDetails = shortDetails;
    this.description = description;
    this.stock = stock;
    this.newPro = newPro;
    this.brand = brand;
    this.sale = sale;
    this.category = category;
    this.tags = tags;
    this.colors = colors;
    this.linkvideo = linkvideo;
    this.sell_in_ligne = sell_in_ligne;
    this.images = images;
    // tslint:disable-next-line:variable-name
    this.image_principale = image_principale;
    this.categories = categories;
    this.fichier_telechargeable = fichier_telechargeable;
    this.by = by;
    this.type = type;
    this.isPublish = isPublish;
    this.souscribe_mode = souscribe_mode;
    this.nbr_oders = nbr_oders;
    this.other_file = other_file;
    this.is_external_link = is_external_link;
    this.external_link = external_link;

  }

 }
  // Color Filter
  export interface ColorFilter {
    color?: ProductColor;
  }
